module.exports = __webpack_public_path__ + "static/media/Slider0_Churrini_V2.e866b511.jpg";